<section class="benefits-grid">

    <div class="container-redesign">

        <div class="benefits-grid__heading">

            <h2 class="benefits-grid__title">
                What mental health teams gain
                with <span>AI-driven monitoring</span>
            </h2>

        </div>

        <div class="benefits-grid__cards">

            <article
                class="benefits-grid__card"
                *ngFor="let benefit of benefits; trackBy: trackByTitle">

                <div class="benefits-grid__icon">

                    <img
                        [src]="'/assets/img/redesign/' + benefit.icon"
                        [alt]="benefit.title">

                </div>

                <h3>{{ benefit.title }}</h3>

                <p>{{ benefit.description }}</p>

            </article>

        </div>

    </div>

</section>